/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiCategoryNotificationConfiguration
 */
export interface InternalApiCategoryNotificationConfiguration {
    /**
     * 
     * @type {string}
     * @memberof InternalApiCategoryNotificationConfiguration
     */
    categoryId: string;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiCategoryNotificationConfiguration
     */
    notifyNewMessage: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiCategoryNotificationConfiguration
     */
    notifyReply: boolean;
}

/**
 * Check if a given object implements the InternalApiCategoryNotificationConfiguration interface.
 */
export function instanceOfInternalApiCategoryNotificationConfiguration(value: object): value is InternalApiCategoryNotificationConfiguration {
    if (!('categoryId' in value) || value['categoryId'] === undefined) return false;
    if (!('notifyNewMessage' in value) || value['notifyNewMessage'] === undefined) return false;
    if (!('notifyReply' in value) || value['notifyReply'] === undefined) return false;
    return true;
}

export function InternalApiCategoryNotificationConfigurationFromJSON(json: any): InternalApiCategoryNotificationConfiguration {
    return InternalApiCategoryNotificationConfigurationFromJSONTyped(json, false);
}

export function InternalApiCategoryNotificationConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCategoryNotificationConfiguration {
    if (json == null) {
        return json;
    }
    return {
        
        'categoryId': json['categoryId'],
        'notifyNewMessage': json['notifyNewMessage'],
        'notifyReply': json['notifyReply'],
    };
}

export function InternalApiCategoryNotificationConfigurationToJSON(json: any): InternalApiCategoryNotificationConfiguration {
    return InternalApiCategoryNotificationConfigurationToJSONTyped(json, false);
}

export function InternalApiCategoryNotificationConfigurationToJSONTyped(value?: InternalApiCategoryNotificationConfiguration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'categoryId': value['categoryId'],
        'notifyNewMessage': value['notifyNewMessage'],
        'notifyReply': value['notifyReply'],
    };
}

